import React from 'react';

import styles  from "./DataDisplay.module.css";
import SimpleFormView from '../../../../Components/UI/Form/FormUtils/SimpleFormView';

const DataDisplay = (props) => {
  const answers =  (Object.keys(props.data.answers).length === 0 ? null: <SimpleFormView form={props.data.answers} /> );

  return <>
    <div className={styles.DataDisplay}>
      <div className={styles.DataBlock}>
        { props.hasImage &&
          <div>
            <img src={props.hasImage} width="200px" />
          </div>
        }
        <br />
        Patient: {props.data?.first_name} {props.data?.name}<br />
        Kontakt: {props.data?.email} {props.data?.phone}<br />
        Arzt: {props.data?.physician}<br />
        <br/>
        Unterzeichnet<br />
        {props.data?.sig_place}, {props.data?.sig_date}<br />
        {props.data?.sig_first_name} {props.data?.sig_name}<br />
      </div>
    </div>
    {answers}
  </>  
}

export default DataDisplay;
